export default import.meta.ROLLUP_FILE_URL_NHJ6QB3ZVMf35ip30RyL0A;